"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _I18n = _interopRequireDefault(require("I18n"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var ImmutableModel = _interopRequireWildcard(require("customer-data-objects/model/ImmutableModel"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _FollowUpArea = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/followUpTask/FollowUpArea"));

var _NotificationAreaWithFollowup = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/followUpTask/NotificationAreaWithFollowup"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _FollowUpTaskContainer = _interopRequireDefault(require("crm_ui/followUpTask/FollowUpTaskContainer"));

var _eventNames = require("customer-data-tracking/constants/eventNames");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

function _default(Component) {
  var InteractionWithFollowUpTask = (0, _createReactClass.default)({
    displayName: 'InteractionWithFollowUpTask',
    propTypes: {
      associations: _reactImmutableProptypes.default.map,
      subjectId: _propTypes.default.string,
      hasTasksUX2Gate: _propTypes.default.bool,
      localInteraction: _propTypes.default.object,
      onCompleteSave: _propTypes.default.func,
      onCompleteTaskWithFollowUp: _propTypes.default.func,
      objectType: _ObjectTypesType.default,
      subject: _SubjectType.default,
      descriptor: _propTypes.default.instanceOf(_InteractionDescriptorRecord.default),
      engagementType: _propTypes.default.string,
      handleCreateFollowUpTask: _propTypes.default.func,
      handleFollowUpCategoryChange: _propTypes.default.func,
      handleFollowUpTaskToggle: _propTypes.default.func,
      handleGetFollowUpTimestamp: _propTypes.default.func,
      followUpCategories: _propTypes.default.array,
      includeFollowUpTask: _propTypes.default.bool,
      selectedFollowUpCategory: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
      interaction: _propTypes.default.instanceOf(_InteractionRecord.default),
      onCreateFollowupTask: _propTypes.default.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        onCompleteSave: _emptyFunction.default
      };
    },
    getFollowUpTaskMetadata: function getFollowUpTaskMetadata() {
      var _this$props = this.props,
          localInteraction = _this$props.localInteraction,
          descriptor = _this$props.descriptor,
          subject = _this$props.subject,
          objectType = _this$props.objectType,
          handleGetFollowUpTimestamp = _this$props.handleGetFollowUpTimestamp,
          interaction = _this$props.interaction,
          engagementType = _this$props.engagementType;
      var timestamp = handleGetFollowUpTimestamp();
      var type;
      var taskSubject;
      var taskBody;

      if (descriptor) {
        type = descriptor.type;
      } else {
        type = engagementType;
      }

      if (objectType === _ObjectTypes.DEAL) {
        taskSubject = (0, _unescapedText.default)('interactionWithFollowUpTask.followUpTaskSubjectDeal', {
          subject: ImmutableModel.toString(subject)
        });
      } else {
        taskSubject = (0, _unescapedText.default)('interactionWithFollowUpTask.followUpTaskSubject', {
          subject: ImmutableModel.toString(subject)
        });
      }

      if (type === _InteractionTypes.EMAIL) {
        var emailSubject;

        if (interaction && interaction.getIn(['metadata', 'subject'])) {
          emailSubject = interaction.getIn(['metadata', 'subject']);
        } else if (localInteraction) {
          emailSubject = localInteraction.data.getIn(['email', 'subject']);
        }

        taskBody = _I18n.default.text('interactionWithFollowUpTask.taskBody.EMAIL', {
          subject: emailSubject,
          date: _I18n.default.moment.userTz().format('LLLL')
        });
      } else if (type === _InteractionTypes.NOTE) {
        taskBody = _I18n.default.text('interactionWithFollowUpTask.taskBody.NOTE', {
          date: _I18n.default.moment.userTz().format('LLLL')
        });
      } else if (type === _InteractionTypes.TASK) {
        taskBody = _I18n.default.text('interactionWithFollowUpTask.taskBody.TASK', {
          subject: localInteraction.data.get('task').metadata.get('subject'),
          date: _I18n.default.moment.userTz().format('LLLL')
        });
      } else if (type === _InteractionTypes.CALL) {
        taskBody = _I18n.default.text('interactionWithFollowUpTask.taskBody.CALL', {
          date: _I18n.default.moment.userTz().format('LLLL')
        });
      } else if (type === _InteractionTypes.LOGGED_EMAIL || type === _InteractionTypes.LOGGED_CALL || type === _InteractionTypes.LOGGED_MEETING) {
        taskBody = _I18n.default.text("interactionWithFollowUpTask.taskBodyLog." + engagementType, {
          date: _I18n.default.moment.userTz().format('LLLL')
        });
      }

      return {
        reminders: [timestamp],
        subject: taskSubject,
        body: taskBody
      };
    },
    createFollowUpTask: function createFollowUpTask() {
      var metadata = this.getFollowUpTaskMetadata();
      var _this$props2 = this.props,
          onCompleteTaskWithFollowUp = _this$props2.onCompleteTaskWithFollowUp,
          onCompleteSave = _this$props2.onCompleteSave,
          handleCreateFollowUpTask = _this$props2.handleCreateFollowUpTask,
          associations = _this$props2.associations;
      handleCreateFollowUpTask({
        associations: associations,
        metadata: metadata
      }, _eventNames.RECORD_INTERACTION);
      onCompleteTaskWithFollowUp();
      onCompleteSave();
    },
    getNotificationAreaProps: function getNotificationAreaProps() {
      var _this$props3 = this.props,
          objectType = _this$props3.objectType,
          followUpCategories = _this$props3.followUpCategories,
          includeFollowUpTask = _this$props3.includeFollowUpTask,
          selectedFollowUpCategory = _this$props3.selectedFollowUpCategory,
          handleFollowUpCategoryChange = _this$props3.handleFollowUpCategoryChange,
          handleFollowUpTaskToggle = _this$props3.handleFollowUpTaskToggle;
      return {
        objectType: objectType,
        controlsButtonsClassName: 'justify-start',
        followUpDateCategories: followUpCategories,
        handleFollowUpTaskToggle: handleFollowUpTaskToggle,
        handleFollowUpCategoryChange: handleFollowUpCategoryChange,
        selectedFollowUpCategory: selectedFollowUpCategory,
        includeFollowUpTask: includeFollowUpTask
      };
    },
    render: function render() {
      // TODO: remove after ungating Tasks:UsabilityImprovements:V2
      var NotificationAreaComponent = this.props.hasTasksUX2Gate ? _FollowUpArea.default : _NotificationAreaWithFollowup.default;
      return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
        NotificationAreaComponent: NotificationAreaComponent,
        notificationAreaProps: this.getNotificationAreaProps(),
        onCompleteSave: this.createFollowUpTask
      }));
    }
  });
  return (0, _FollowUpTaskContainer.default)(InteractionWithFollowUpTask, {});
}

module.exports = exports.default;